import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const today = () => new Date().toISOString().split("T")[0]

export function formatEventDate(date: Date): string {
  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)

  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate())
  const dateStart = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  const daysDiff = Math.floor((dateStart.getTime() - todayStart.getTime()) / (1000 * 60 * 60 * 24))

  if (daysDiff >= 7) return date.toLocaleDateString("ru-RU", { day: "numeric", month: "long" }).replace(".", "")
  if (date.toDateString() === today.toDateString()) return "Сегодня"
  if (date.toDateString() === tomorrow.toDateString()) return "Завтра"
  const day = date.toLocaleDateString("ru-RU", { weekday: "short" })
  return day.charAt(0).toUpperCase() + day.slice(1)
}

export function formatEventTimeRange(start: Date, endTime?: Date): string {
  const startStr = start.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" })
  if (!endTime) return startStr
  return `${startStr} - ${endTime.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" })}`
}
